import ENVIRONMENT from '@/environments/environment';
import { ClientTaxonomyProps } from '@/interfaces/AnalyticsInterface/AnalyticsInterface';
import { Analytics } from '@/services/analytics';

import {
  PaidSummary,
  PaidSummaryAPIData,
  Settlement,
  Settlements,
  SettlementsAPIData,
} from '../../interfaces/ReportingInterface/ReportingInterface';
import Api from '../../utils/apiHelper';
import MethodDashboard from '../../utils/dashboardMethod';
import {
  allResponse,
  OrderSortType,
  OrderType,
  SortType,
} from '../operation/operationsInterface';

const {
  DASHBOARD_SETTLEMENTS,
  DASHBOARD_PAID_SUMMARY,
  DASHBOARD_SETTLEMENTS_FILTERS,
} = ENVIRONMENT.URL_API_DASHBOARD_APIS;

const ReportingAPI = {
  getSettlements: async (
    params: SettlementsAPIData,
    orderBy?: OrderSortType,
  ): Promise<allResponse<Settlements>> => {
    const URL = ENVIRONMENT.URL_API_DASHBOARD
      + DASHBOARD_SETTLEMENTS
      + DASHBOARD_SETTLEMENTS_FILTERS;
    const newURL = MethodDashboard(URL, params, orderBy);
    const response = await Api.GET(newURL);
    return response;
  },
  getPaidSummary: async (
    params: PaidSummaryAPIData,
  ): Promise<allResponse<PaidSummary>> => {
    const URL = ENVIRONMENT.URL_API_DASHBOARD + DASHBOARD_PAID_SUMMARY;
    const response = await Api.GET(URL, { params });
    const summaries = response.data.dashboards_summaries;
    Analytics.setAnalyticsUserProperties({
      [ClientTaxonomyProps.MTD_ACT_AMOUNT_SUM]:
      summaries[0]?.total_amount ? summaries[0].total_amount.toString() : '',
      [ClientTaxonomyProps.MTD_ACT_LOANS_COUNT]:
      summaries[0]?.total_loans ? summaries[0].total_loans.toString() : '',
      [ClientTaxonomyProps.LM_ACT_AMOUNT_SUM]:
      summaries[1]?.total_amount ? summaries[1].total_amount.toString() : '',
      [ClientTaxonomyProps.LM_ACT_LOANS_COUNT]:
      summaries[1]?.total_loans ? summaries[1].total_loans.toString() : '',
    });
    return response;
  },
  getSettlementDetail: async (
    settlementId: string,
    params?: SettlementsAPIData,
  ): Promise<allResponse<Settlement>> => {
    const URL = `${
      ENVIRONMENT.URL_API_DASHBOARD + DASHBOARD_SETTLEMENTS
    }/${settlementId}${DASHBOARD_SETTLEMENTS_FILTERS}`;
    const newURL = MethodDashboard(URL, params, {
      order: OrderType.DATE,
      sort: SortType.ASC,
    });
    const response = await Api.GET(newURL);
    return response;
  },
};

export const { getSettlements, getPaidSummary, getSettlementDetail } = ReportingAPI;
